module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship2.be061e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship2.png
// module id = tcq+
// module chunks = 0